﻿package org.zq.pixelset.model

/** 缩放：按目标尺寸输出；仅压缩：保持编辑后尺寸，只调整格式与质量；格式转换：仅转换格式，不做任何编辑。 */
enum class ProcessingMode(val label: String) {
    Resize("缩放"),
    Compress("仅压缩"),
    Convert("格式转换"),
}
